import axios from 'axios'
import { baseURL } from '..'

// Lấy danh sách voucher Shopee
export const getVoucherShopee = async () => {
    try {
        const res = await axios.get(`${baseURL}/api/shopee/getVoucher`)
        return res.data
    } catch (err) {
        console.error('Error fetching vouchers:', err)
        return null
    }
}

// Lấy danh sách voucher Freeship Shopee
export const getFreeshipShopee = async () => {
    try {
        const res = await axios.get(`${baseURL}/api/shopee/getFreeship`)
        return res.data
    } catch (err) {
        console.error('Error fetching freeship vouchers:', err)
        return null
    }
}

// Lưu voucher Shopee (cookie + theo từng voucher)
export const saveVoucherShopee = async (cookie, voucher_promotionid, signature, voucher_code) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/saveVoucherShopee`, {
            cookie,
            voucher_promotionid,
            signature,
            voucher_code,
        })
        return res.data
    } catch (err) {
        console.error('Error saving voucher:', err)
        return null
    }
}

// Lấy danh sách quest/nhiệm vụ
export const getQuest = async (cookie, userId) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/getquest`, {
            cookie,
            userId,
        })
        return res.data
    } catch (err) {
        console.error('Error fetching quests:', err)
        return null
    }
}

// Follow shop
export const followShop = async (cookie, shopid) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/followShop`, {
            cookie,
            shopid,
        })
        return res.data
    } catch (err) {
        console.error('Error following shop:', err)
        return null
    }
}

// Lấy thông tin coin của user
export const getUserCoins = async (cookie) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/getUserCoins`, {
            cookie,
        })
        return res.data
    } catch (err) {
        console.error('Error fetching user coins:', err)
        return null
    }
}

// Nhận phần thưởng từ task
export const getReward = async (cookie, taskId, userId) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/getReward`, {
            cookie,
            taskId,
            userId
        })
        return res.data
    } catch (err) {
        console.error('Error getting reward:', err)
        return null
    }
}

// Lấy voucher có thể mua bằng coin
export const getVoucherWithCoin = async (cookie) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/getvoucherwithcoin`, {
            cookie,
        })
        return res.data
    } catch (err) {
        console.error('Error fetching voucher with coin:', err)
        return null
    }
}

// Claim voucher bằng coin
export const claimVoucherWithCoin = async (cookie, benefit_id, voucher_code) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/claimVoucherWithCoin`, {
            cookie,
            benefit_id,
            voucher_code,
        })
        return res.data
    } catch (err) {
        console.error('Error claiming voucher with coin:', err)
        return null
    }
}

export default {
    getVoucherShopee,
    getFreeshipShopee,
    saveVoucherShopee,
    getQuest,
    followShop,
    getUserCoins,
    getReward,
    getVoucherWithCoin,
    claimVoucherWithCoin,
}
